import { ConfigInterface, responseInterface } from 'swr';
import { wpApi, useWPApi, parseUrl, DeepQueryParams } from '@gik/core/api';
import PostsUrlBuilder from './PostsUrlBuilder';
import WordpressPost from '@gik/core/models/wordpress/WordpressPost';

const path = 'posts';

function getParams(slug: string, perPage = 4): DeepQueryParams {
  // prettier-ignore
  return new PostsUrlBuilder()
    .withPerPage(perPage)
    .withSingleTaxonomyItem({
      taxonomy: 'featured-content',
      terms: slug
    })
    .params;
}

export function getPostsFeatured(slug: string, perPage?: number) {
  const finalUrl = parseUrl(path, {
    deepQueryParams: getParams(slug, perPage),
  });
  return wpApi.get(finalUrl);
}

export function usePostsFeatured(
  slug: string,
  perPage?: number,
  config?: ConfigInterface
): responseInterface<WordpressPost[], Error> {
  return useWPApi<WordpressPost[], Error>(path, config, { deepQueryParams: getParams(slug, perPage) });
}
